export const SHOW__MODALE = 'modale/SHOW__MODALE';
export const HIDE__MODALE = 'modale/HIDE__MODALE';
export const UPDATE_MODALE = 'modale/UPDATE_MODALE';
export const RESET_MODALE_STACK = 'modale/RESET_MODALE_STACK';
